module.exports = __webpack_public_path__ + "img/fuli_zh_CN_img1.2b48edef.png";